import { isIterableSet } from './is.utils.js';

function iterToSet(iterable) {
    return isIterableSet(iterable) ? iterable : new Set(iterable);
}
function mergeIterables(...iterables) {
    const items = [];
    iterables.forEach((iterable)=>{
        if (iterable) {
            items.push(...Array.from(iterable));
        }
    });
    return new Set(items);
}

export { iterToSet, mergeIterables };
